module.exports = __webpack_public_path__ + "static/media/united-kingdom.e5564902.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/Flags/united-kingdom.svg
// module id = 244
// module chunks = 0